import styled from 'styled-components';
import { breakpoints } from 'modules/v2/foundation/breakpoints';
import { padding, pxToRem } from 'modules/v2/foundation/spacing';
import { themeGet } from 'modules/v2/foundation/theme';
export const HEIGHT = 64;
export const TopBarContainer = styled.div `
  flex: 0 0 auto;
  width: 100%;
  position: sticky;
  top: 0;
  height: ${pxToRem(HEIGHT)};
  border-bottom: ${pxToRem(1)} solid ${themeGet('colors.gray.100')};
  box-sizing: content-box;
`;
export const TopBarHeader = styled.header `
  ${padding(0, 4)};
  display: flex;
  box-sizing: border-box;
  align-items: center;
  justify-content: space-between;
  height: ${pxToRem(HEIGHT)};
  max-width: ${pxToRem(1440)};
  margin-left: auto;
  margin-right: auto;
  background-color: ${themeGet('colors.gray.0')};

  ${breakpoints.desktop} {
    ${padding(0, 6)};
  }
`;
export const Left = styled.div `
  display: inline-flex;
  align-items: center;
  margin-right: auto;
`;
export const Right = styled.div `
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-left: auto;
`;
